<script lang="ts" setup>
import type { BreadcrumbLinkProps } from '.';

import { cn } from '@/utils';
import NuxtLink from '#app/components/nuxt-link.js';

const props = withDefaults(defineProps<BreadcrumbLinkProps>(), {
	as: 'a'
});

const isValidTo = computed(() => {
	return typeof props.to === 'string' || typeof props.to === 'object';
});
</script>

<template>
	<Component
		:is="isValidTo ? NuxtLink : 'span'"
		:as="as"
		:as-child="asChild"
		:to="to"
		:class="cn('transition-colors hover:text-foreground', props.class)"
	>
		<slot />
	</Component>
</template>
